'use strict';

var toConsumableArray = require('../../../node_modules/@babel/runtime/helpers/toConsumableArray.js');
var React = require('react');
require('prop-types');
var Grid = require('../Grid/Grid.js');
var makeStyles = require('../../../node_modules/@material-ui/core/esm/styles/makeStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var VARIANT_GRID = {
  'full': {
    xs: [12],
    sm: [12],
    md: [12],
    lg: [12]
  },
  'left-panel': {
    xs: [12, 12],
    sm: [12, 12],
    md: [4, 8],
    lg: [4, 8]
  },
  'right-panel': {
    xs: [12, 12],
    sm: [12, 12],
    md: [8, 4],
    lg: [8, 4]
  },
  'split': {
    xs: [12, 12],
    sm: [6, 6],
    md: [6, 6],
    lg: [6, 6]
  },
  'middle': {
    xs: [12, 12, 12],
    sm: [12, 12, 12],
    md: [3, 6, 3],
    lg: [3, 6, 3]
  },
  'even': {
    xs: [12, 12, 12],
    sm: [12, 12, 12],
    md: [4, 4, 4],
    lg: [4, 4, 4]
  }
};
var VARIANT_GRID_COUNT = {
  'full': 1,
  'left-panel': 2,
  'right-panel': 2,
  'split': 2,
  'middle': 3,
  'even': 3
};
var warnedOnce = false;
var useStyles = makeStyles(function () {
  return {
    root: {
      maxWidth: 1900
    }
  };
});

var LayoutTemplate = function LayoutTemplate(_ref) {
  var children = _ref.children,
      variant = _ref.variant,
      spacing = _ref.spacing;
  var classes = useStyles();

  if (process.env.NODE_ENV !== 'production' && !warnedOnce && !variant) {
    console.warn("Housecall-UI: The LayoutTemplate component requires a variant. \n\n You should pass in one of the following variants: full, leftPanel, rightPanel, split, middle or even");
    warnedOnce = true;
  }

  var variantValues = VARIANT_GRID[variant] || [];
  var variantGridCount = VARIANT_GRID_COUNT[variant] || 0;
  var childrenCount = React__default["default"].Children.count(children);

  if (process.env.NODE_ENV !== 'production' && !variant && !children || childrenCount > 3 || childrenCount === 0) {
    console.warn("Housecall-UI: The LayoutTemplate component requires 1 valid child or up to 3 valid children.");
    warnedOnce = true;
    return null;
  } else if (process.env.NODE_ENV !== 'production' && variantGridCount !== childrenCount) {
    console.warn("Housecall-UI: The variant passed in and the number of children does not match.");
    warnedOnce = true;
  }

  var childrenArray = React__default["default"].Children.map(children, function (child) {
    if (process.env.NODE_ENV !== 'production' && !React__default["default"].isValidElement(child)) {
      console.warn("Housecall-UI: Child is not a valid element.");
      warnedOnce = true;
      return null;
    }

    if (!Array.isArray(child.props.children)) {
      return child;
    } else {
      var grandChildrenArray = React__default["default"].Children.map(child.props.children, function (grandChild) {
        if (process.env.NODE_ENV !== 'production' && !React__default["default"].isValidElement(grandChild)) {
          console.warn("Housecall-UI: Child is not a valid element.");
          warnedOnce = true;
          return null;
        }

        return React__default["default"].createElement(Grid, {
          item: true
        }, grandChild);
      });
      return React__default["default"].createElement(Grid, {
        item: true,
        container: true,
        direction: "column",
        spacing: 1
      }, grandChildrenArray);
    }
  });

  var renderChildren = toConsumableArray(Array(variantGridCount)).map(function (_, i) {
    return React__default["default"].createElement(Grid, {
      item: true,
      key: "layout-item-".concat(i),
      xs: variantValues['xs'][i],
      sm: variantValues['sm'][i],
      md: variantValues['md'][i],
      lg: variantValues['lg'][i]
    }, childrenArray[i]);
  });

  return React__default["default"].createElement(Grid, {
    className: classes.root,
    justify: "center",
    spacing: spacing,
    container: true
  }, renderChildren);
};
LayoutTemplate.defaultProps = {
  children: [],
  spacing: 1
};

module.exports = LayoutTemplate;
